import React from 'react'
import { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormInput from '../../../components/forms/formInput'
import FormTextarea from '../../../components/forms/formTextarea'
import Button from '../../../components/forms/blackfillButton'
import HelpFunctions from '../../../functions/dashboard/help'

const Add = ({setValues}) => {
    const [subject,setSubject] = useState('');
    const [message,setMessage] = useState('');
    const reset = ()=>{
        setSubject(''); setMessage('');
    }
  return (
    <div className='admin_forms_container'>
      <FormInput Lable='Subject' Type='text' Placeholder='Enter subject' Value={subject} setValue={setSubject}/>
      <FormTextarea Lable='Message' Placeholder='Enter Message' Value={message} setValue={setMessage}/>
      <Button Value={'Save'} Action={
        ()=>{
            HelpFunctions.Post({
                subject : subject,
                message : message,
                department : 0
            },toast,setValues,reset);
        }
      }/>
      <ToastContainer />
    </div>
  )
}

export default Add
